import React, { Suspense } from 'react';
import './App.scss';
import {
	Switch,
	Route
} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useBrowserUpgradeCheck, useMount } from '@mail/m-hooks';

import Header from './module/PC/Header';
import Footer from './module/PC/Footer';
import Main from './module/PC/Main';
import GlobalModalBox from './module/common/GlobalModalBox';
import RedirectToMobile from './module/PC/RedirectToMobile';
import WithAccountStatus from './module/common/WithAccountStatus';

import GlobalMoadlAction from './module/common/GlobalModalBox/action';

import { routes } from './routes';

function App() {
	const dispatch = useDispatch()
	useMount(() => {
		window.addEventListener('hashchange', () => {
			// 路由跳转的时候要关闭正在展示的弹窗
			dispatch({
				type: GlobalMoadlAction.UPDATE_GLOBAL_MODAL,
				playload: {
					show: false
				}
			})
		})
	})
	useBrowserUpgradeCheck();
	return (
		<RedirectToMobile>
			{/* 为了ie9、10的类sticky效果 */}
			<div className="app-header-main">
				<Header />
				<Suspense fallback={<div></div>}>
					<Switch>
						{routes.map(route => (
							<Route key={route.path} path={route.path} exact={route.exact} render={
								() => {
									const Component = WithAccountStatus(route.component, !!route.withAccount, !!route.withStatus, !!route.withPhone);
									return route.withMainLayout ?
										<Main>
											<Component />
										</Main> :
										<Component />
								}
							}></Route>
						))}
					</Switch>
				</Suspense>
			</div>
			<Footer />
			<GlobalModalBox />
		</RedirectToMobile>
  	);
}

export default App;
